import { QUICK_LAUNCH } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useQuickLaunch() {
  return useIsFeatureEnabled(QUICK_LAUNCH);
}
